
import React from 'react';
import { MainNav } from '../navigation/MainNav';
import { NotificationCenter } from '../NotificationCenter';
import { UserMenu } from '../navigation/UserMenu';

interface DesktopNavProps {
  isAuthenticated: boolean;
  isHost: boolean;
  onLogout: () => void;
}

export const DesktopNav: React.FC<DesktopNavProps> = ({
  isAuthenticated,
  isHost,
  onLogout
}) => {
  return (
    <>
      {/* Desktop Navigation */}
      <div className="hidden md:flex md:flex-1 md:justify-center">
        <MainNav isHost={isHost} isAuthenticated={isAuthenticated} />
      </div>

      {/* Desktop Right Side Actions */}
      <div className="hidden md:flex items-center gap-3">
        {isAuthenticated && <NotificationCenter />}
        <UserMenu 
          isHost={isHost} 
          isAuthenticated={isAuthenticated} 
          onLogout={onLogout} 
        />
      </div>
    </>
  );
};
